import React, { useEffect, useState } from "react";

import Panel from "../../shared/bootstrap/Panel.jsx";
import PanelHeader from "../../shared/bootstrap/PanelHeader.jsx";
import Header from "./Header.jsx";
import OrderGeneralInfo from "./OrderGeneralInfo.jsx";
import Contacts from "./Contacts.jsx";
import Attachments from "./Attachments.jsx";
import NotesHistory from "./NotesHistory.jsx";
import Shortcuts from "./Shortcuts.jsx";

import { getOrderDetails } from "../../../api/orderApp.js";

/**
 * OrderDetail Component
 * @param {Object} props
 * @param {function} props.setFetchError
 * @param {number} props.id
 * @param {{firstName: string, lastName: string}} props.user
 * @returns {React.JSX.Element}
 */
export default function OrderDetail({ setFetchError, id, user }) {
  /** @type {[OrderDetails?, React.Dispatch<React.SetActionState<OrderDetails>>]} */
  const [orderDetail, setOrderDetail] = useState();

  useEffect(() => {
    getOrderDetails(id)
    .then(({ data: orderDetailResponse }) => {
      setOrderDetail(orderDetailResponse);
    })
    .catch((error) => {
      setFetchError(error);
    });
  }, [id]);

  if (orderDetail) {
    // using an onClick instead of href b/c url already contains a '#'
    const scrollToTop = () => document.getElementById("TOP").scrollIntoView();
    const scrollToTopElement = (<div className="text-center link clickable" role="link">
      <a onClick={scrollToTop}>Back To Top</a>
    </div>);

    return (<div id="order-app-wrapper" className="container-fluid">
      <div id="TOP"></div>
      <Header stnSeq={id}/>
      <Shortcuts/>
      <Panel id="Order_geninfo" primary={true} className="table-responsive">
        <PanelHeader title="Order General Info"/>
        <OrderGeneralInfo
          stnSeq={id}
          orderStatus={orderDetail.orderStatus}
          deliveryStatus={orderDetail.deliveryStatus}
          expDeliveryDate={orderDetail.expDeliveryDate}
          chDisplayName={orderDetail.chDisplayName}
          chEmailsConcatenated={orderDetail.chEmailsConcatenated}
          orderNumbers={orderDetail.orderNumbers}
          firstName={user.firstName}
          lastName={user.lastName}
          rfqSeqFlag={orderDetail.rfqSeqFlag}
          rfqSeq={orderDetail.rfqSeq}
          companyName={orderDetail.companyName}
          chInfoSeq={orderDetail.chInfoSeq}
          contractNumber={orderDetail.contractNumber}
          orderTotal={orderDetail.orderTotal}
          awardDate={orderDetail.awardDate}
          modDate={orderDetail.modDate}
          modLevel={orderDetail.modLevel}
        />
      </Panel>
      {scrollToTopElement}
      <Panel id="Order_contacts" primary={true} className="table-responsive">
        <PanelHeader title="Contacts"/>
        <Contacts stnSeq={id} existingContacts={orderDetail.existingContacts}/>
      </Panel>
      {scrollToTopElement}
      <Panel id="Order_attachments" primary={true}>
        <PanelHeader title="Attachments"/>
        <Attachments existingAttachments={orderDetail.existingAttachments}/>
      </Panel>
      {scrollToTopElement}
      <Panel id="Order_notesHistory" primary={true}>
        <PanelHeader title="Notes History"/>
        <NotesHistory notesHistoryString={orderDetail.notesHistoryString}/>
      </Panel>
      {scrollToTopElement}
    </div>);
  } else {
    return <div>Loading Order Status...</div>;
  }
}
